<template>
    <div class="EquipmentAccount">
        <div class="left">
            <div class="search">
                <el-input
                    placeholder="输入设备名称以搜索"
                    suffix-icon="el-icon-search"
                    v-model="keyword">
                </el-input>
                <div class="all">全部设备</div>
            </div>
            <div class="mytree">
                <el-tree 
                ref="tree"
                :data="list" 
                default-expand-all 
                :props="defaultProps" 
                @node-click="handleNodeClick"
                :filter-node-method="filterNode">
                    <span class="custom-tree-node row-center" slot-scope="{ node, data }" :class="{ checked: (data.device_id === currentLoop.device_id)&&currentLoop.device_id }">
                        <span class="name" :title="data.device_name"> {{ data.device_name }}</span>
                    </span>
                </el-tree>
            </div>
        </div>
        <div class="right">
            <Detail :currentLoop="currentLoop"></Detail>
            <!-- <Detection :currentLoop="currentLoop"></Detection> -->
        </div>
    </div>
</template>

<script>
import { deviceAll,deviceUps} from "../../api/power";
import {loadBMap} from '@/util/map'
import Detail from './detail'
import Detection from './Detection'
import { subscribe,subscribeByNodesUPS } from '../../mqtt/index'
  export default {
    data() {
      return {
        defaultProps: {
          children: 'device',
          label: 'device_name'
        },
        list:[],
        keyword:"",
        imglist:[
            require("../../assets/img/gf1.png"),
            require("../../assets/img/pd1.png"),
            require("../../assets/img/wg1.png")
        ],
        currentLoop:{},
      };
    },
    components:{
        Detail,Detection
    },
    computed:{
        projectInfo(){
            return this.$store.state.project.projectInfo
        },
        EnterpriseInfo(){
            return this.$store.state.project.EnterpriseInfo
        },
        result() {
            let onRecursionData = (arr, val) => {
                let newarr = []
                arr.forEach(item => {
                    if (item.children && item.children.length) {
                        let children = onRecursionData(item.children, val)
                        let obj = {
                            ...item,
                            children
                        }
                        if (children && children.length) {
                            newarr.push(obj)
                        }
                    } else {
                        if (item.label.includes(val)) {
                            newarr.push(item)
                        }
                    }
                })
                return newarr
            }
            let result = onRecursionData(this.list, this.keyword)
            // console.log(result,"result",this.list)
            return result
        }
    },
    watch:{
        list(n,o){

        },
        keyword(val){
            this.$refs.tree.filter(val);
        }
    },
    mounted(){
        this.getDeviceAll()
    },
    methods:{
        
        filterNode(value, data) {
            if (!value) return true;
            return data.device_name.indexOf(value) !== -1;
        },
        
        handleNodeClick(data){
            if(!data.check){
                this.currentLoop = data;
            }
        },
        async getDeviceAll(){
            let result = await deviceUps();
            let data = result.data.data
            this.list = data.map(e=>{
                e.device_name = e.area
                e.check = true
                if(e.device){
                    e.device = e.device.map(l=>{
                        if(l.loop_url){
                            l.loop_url = l.loop_url.replace(this.$store.state.project.projectInfo.influxDbName+'/',"")
                            subscribeByNodesUPS([l.loop_url]);
                        }
                        return l
                    })
                }
                return e
            })
            if(this.list[0].device.length>0){
                this.currentLoop = this.list[0].device[0]
            }else if(this.list[1].device.length>0){
                this.currentLoop = this.list[1].device[0]
            }
            // this.currentLoop = this.list[0].device[0]
        },
    }
  };
</script>

<style scoped lang="less">

/deep/ .mytree   {
    height: calc(100% - 10vh);
    // padding: 10px;
    padding-right: 20rem;
   overflow-y:auto;
   .el-tree{
    color: #333333;
   }
   .el-tree > .el-tree-node:after {
     border-top: none;
   }
   .el-tree-node {
     position: relative;
    //  padding-left: 12px;
     .el-tree-node__children{
        
        .el-tree-node__children{
            border:0
        }
        .el-tree-node__content{
            background: none;
            margin-bottom: 0px;
        }
     }
   }
   
   
   //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
   .el-tree-node__expand-icon.is-leaf {
     display: none;
   }
   .el-tree-node__children {
     padding-left: 18px;
     border: 1px solid #F2F2F2;
     border-radius: 0px 0px 4px 4px;
   }

   .el-tree-node :last-child:before {
    //  height: 38px;
   }

   .el-tree > .el-tree-node:before {
     border-left: none;
   }

   .el-tree > .el-tree-node:after {
     border-top: none;
   }

//    .el-tree-node:before {
//      content: '';
//      left: 0px;
//      position: absolute;
//      right: auto;
//      border-width: 1px;
//    }

//    .el-tree-node:after {
//      content: '';
//      left: 0px;
//      position: absolute;
//      right: auto;
//      border-width: 1px;
//      border-top: 1px dashed #E5E5E5;
//      height: 20px;
//      top: 14px;
//      width: 16px;
//    }

//    .el-tree-node:before {
//      border-left: 1px dashed #E5E5E5;
//      bottom: 0px;
//      height: 20px;
//      top: 4px;
//      width: 1px;
//    }
   .el-tree .el-tree-node__expand-icon.expanded {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    .el-tree .el-icon-caret-right:before {
      content: "\e6e0";
    //   border: 1px solid #666;
    //   border-radius: 2px;
    //   height: 14px;
    //   width: 14px;
    //   line-height: 14px;
    //   font-size:  16px;
    //   color:  #666;
    //   text-align: center;
    //   position:  absolute;
    //   left:  -20px;
    //   top:  -8px;
    }
    .el-tree .el-tree-node__expand-icon.expanded.el-icon-caret-right:before{
      content: "\e6df";
    //   font-size : 18px;
    //   color:  #666;
    //   line-height: 12px;
    //   position:  absolute;
    //   left:  -20px;
    //   top : -8px;
   }
   .el-tree-node .el-tree-node__children .el-tree-node__children .el-tree-node__children{
    // padding-left: 18px !important;
    .el-tree-node__content{
        // padding-left: 0 !important;
    }
   }
   .el-tree-node__content{
        height: 32px;
        padding-left: 10px !important;
        background: #F2F2F2;
        border-radius: 4px;
        margin-bottom: 10px;
   }
   .el-tree-node__expand-icon{
    font-weight: bold;
    position: absolute;
    right: 12px;
    color:#333333;
    font-size: 18px;
   }
   .el-tree-node__content>.el-tree-node__expand-icon {
     padding : 0;
   }
   .is-leaf+.custom-tree-node{
    font-weight: 400;
   }
   .custom-tree-node{
		width: 100%;
        font-size: 14px;
        justify-content: space-between;
        padding-right: 10px;
        font-weight: 600;
        .name{
            display: inline-block;
            // width:79%;
            overflow:hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            vertical-align: middle;
        }
        label{
            font-weight: bold;
        }
   }
   .el-tree-node__children{
    .custom-tree-node::before{
        content: '';
        background: url(../../assets/img/line.png);
        width: 7px;
        height: 14px;
        display: inline-block;
        position: absolute;
        left: 0;
    }
    .checked{
        color: #0D94FF;
    }
    .checked::before{
        content: '';
        background: url(../../assets/img/line-a.png);
        width: 7px;
        height: 14px;
        display: inline-block;
    }
   }
   
 }

.EquipmentAccount{
    background: #ffffff;
    height: 100%;
    width: 100%;
    display: flex;
    padding: 24rem;
    .left{
        .w(285);
        height: 100%;
        border-right: 1px solid rgba(51, 51, 51, 0.15);
        // padding-right: 24rem;
        .all{
            font-size: 14px;
            line-height: 50px;
        }
    }
    .search{
        padding-right: 24rem;
    }
    .right{
        flex: 1;
        padding-left: 24rem;
    }
}

</style>